var map = {
	"./about-us/about-banner-1.jpg": 5404,
	"./about-us/about-banner-2.jpg": 2330,
	"./about-us/about-us-1.jpg": 354,
	"./about-us/about-us-2.jpg": 2498,
	"./contact-us/contact-banner-1.jpg": 3360,
	"./contact-us/contact-email.svg": 57,
	"./contact-us/contact-us-map-mobile.jpg": 6985,
	"./contact-us/contact-us-map.jpg": 8071,
	"./footer/contact-email.svg": 4979,
	"./home/about-image-1.jpg": 3186,
	"./home/home-page-banner-1.jpg": 7238,
	"./home/home-page-banner-2.jpg": 8119,
	"./home/home-page-banner-3-updated.jpg": 6705,
	"./home/home-page-banner-3.jpg": 3150,
	"./home/home-page-header-banner-1-updated.jpg": 4910,
	"./home/home-page-header-banner-1.jpg": 7004,
	"./home/home-page-header-banner-2.jpg": 4426,
	"./home/home-page-header-banner-3.jpg": 8944,
	"./home/home-page-header-banner-4.jpg": 9042,
	"./logo/logo.png": 8050,
	"./misc/graphic-element-1.png": 3438,
	"./misc/graphic-element-2.png": 6501,
	"./misc/graphic-element-3.png": 3161,
	"./product-range/product-banner-1.jpg": 4580,
	"./product-range/product-images/floorcare/berkart-multi-force.jpg": 7914,
	"./product-range/product-images/floorcare/berkart-multi-vac-20.jpg": 3748,
	"./product-range/product-images/floorcare/brekart-aero-force.jpg": 4620,
	"./product-range/product-images/small-household-appliances/berkart-dripod.jpg": 9940,
	"./product-range/product-images/small-kitchen-appliances/berkart-air-fryer-23L.jpg": 1651,
	"./product-range/product-images/small-kitchen-appliances/berkart-air-fryer-4L.jpg": 3273,
	"./product-range/product-images/small-kitchen-appliances/berkart-air-fryer-5.5L.jpg": 5250,
	"./product-range/product-images/small-kitchen-appliances/berkart-air-fryer-9L-tray.jpg": 8087,
	"./product-range/product-images/small-kitchen-appliances/berkart-air-fryer-9L.jpg": 4076,
	"./product-range/product-images/small-kitchen-appliances/berkart-blend-meister-1000.jpg": 9836,
	"./product-range/product-images/small-kitchen-appliances/berkart-blender-force-500.jpg": 1692,
	"./product-range/product-images/small-kitchen-appliances/berkart-multi-cooker-6L.jpg": 7842,
	"./product-range/product-images/small-kitchen-appliances/berkart-multi-cooker-8L.jpg": 5008,
	"./product-range/product-images/small-kitchen-appliances/berkart-nutri-art-1000.jpg": 5001,
	"./register-warranty/register-background-element.jpg": 9290,
	"./register-warranty/warranty-banner-1.jpg": 9816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;